
import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';

import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { TblLeadChannel } from 'src/app/shared/models/lead-channel';
import { LeadChannelService } from 'src/app/shared/services/LeadChannelService';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { EditLeadChannelDialogComponent } from './edit-lead-channel-dialog.component';
import { PagerService } from 'src/app/shared/pagination';

@Component({
  selector: 'app-lead-channel',
  templateUrl: './lead-channel.component.html',
  styleUrls: ['./lead-channel.component.css']
})
export class LeadChannelComponent implements OnInit {

  model: TblLeadChannel;
  members: Observable<TblLeadChannel[]>;
  allItems: TblLeadChannel[] = [];
  pagedItems: TblLeadChannel[] = [];
  pager: any = {};
  userType: string;
  
  constructor(private _leadChannelService : LeadChannelService,
    private dialog: MatDialog,
    private modalService: BsModalService,
    private localStorage:LocalStorageService,
    private spinnerService: AppComponent,
    private notifyService : NotificationService,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.model=new TblLeadChannel();
    this.getAllData();
  }
  
  getAllData(){
    //this.spinnerService.spinnerChannel(true);
    this.members= this._leadChannelService.getAllLeadChannel();
    this.members.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
    //this.spinnerService.spinnerChannel(false);
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  openAddDialog() {
    const model = new TblLeadChannel();
    const dialogRef = this.dialog.open(EditLeadChannelDialogComponent, {
      width: '500px',
      data: { title: 'Add New Lead Channel', model: model, isEditing: false }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.model = result.model;
        this.create_edit_after_dialog(false);
      }
    });
  }

  openEditDialog(id: any) {
    this._leadChannelService.getLeadChannelById(id).subscribe(resp => {
      const dialogRef = this.dialog.open(EditLeadChannelDialogComponent, {
        width: '500px',
        data: { title: 'Edit Lead Channel', model: resp, isEditing: true }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.action === 'save') {
          this.model = result.model;
          this.create_edit_after_dialog(true);
        }
      });
    });
  }


  //Editing Data
  validateForm():boolean{
    if(!this.model.channelName){
      this.notifyService.showError("Email ID can not be empty!", "Error");
      return false;
    }
    else {
      return true;
    }
  }
  deleteClick(id:any)
  {
    let modalConfig: any = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = {mode:'Delete',  module: 'Lead Channel', refNo:id};
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }))
  }
  create_edit_after_dialog(isEditing: boolean){
    if(!this.validateForm()){
      return;
    }
    this._leadChannelService.saveAndUpdateLeadChannel(this.model).subscribe(resp=>{
      if(resp.refNo>0){
        this.notifyService.showSuccess(isEditing ? "Updated Successfully!" : "Saved Successfully!", "Success");
        this.getAllData()
      }
      else{
        this.notifyService.showError(resp.message, "Error")
      }
    },(err) => {
      this.notifyService.showError(err, "Error")
    });
  }
  close_clicked()
  {
    this.getAllData();
  }
  stopPropagation(event){
    event.stopPropagation();
    }
  searchTable() {
    var term, table;
    term=document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table =document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) ==
            -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
}
}

